export const orderListElement = {
    orderNumber: "Numéro de commande",
    orderDate: "Date de la commande",
    orderSum: "Somme",
    shippingCost: "Frais de port",
    // TODO: add translations
    status:  "État de commande"
}
export const orderList = {
    orderHistory: "HISTORIQUE DE LA COMMANDE"
}
